import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { PapiGallection } from '@wix/da-papi-types';
import ListItemDiv from '@wix/da-ds/pkg/List/ListItem/dsPresets/ListItemDiv';
import Flex from '@wix/da-ds/pkg/Flex';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import StatItem from '../../../StudioDeviationList/_partials/StatItem';
import PremiumGalleryThumb from '../../../StudioDeviationList/items/PremiumGalleryListItem/_partials/PremiumGalleryThumb';
import PremiumGalleryPriceEdit from '../../../StudioDeviationList/_partials/PremiumGalleryPriceEdit';
import PremiumGalleryActions from '../../../StudioDeviationList/items/PremiumGalleryListItem/_partials/PremiumGalleryActions';

import s from './PremiumGalleryListItem.scss';

interface Props {
  gallery: PapiGallection;
}

const PremiumGalleryListItem: FC<Props> = ({ gallery }) => {
  const { t } = useTranslation();
  const viewUrl = Url.studioGallery(gallery.folderId);
  const deviationsCount = gallery.totalItemCount ?? 0;
  const subscribersCount = gallery.premiumFolderData?.numSubscribers ?? 0;
  const statsAndControls = (
    <Flex className={s['stats-and-controls']} gap={24} alignItems="flex-end">
      <PremiumGalleryPriceEdit gallery={gallery} />
      <StatItem
        title={t('studio.products.premiumGalleries.stats.deviations')}
        value={deviationsCount}
        linkTo={deviationsCount > 0 ? viewUrl : undefined}
      />
      <StatItem
        title={t('studio.products.premiumGalleries.stats.supporters')}
        value={subscribersCount}
        linkTo={
          subscribersCount > 0
            ? Url.customerDashboard(gallery.premiumFolderData?.subproductId)
            : undefined
        }
      />
    </Flex>
  );
  return (
    <ListItemDiv
      className={s['root']}
      prefix={
        <PlainButtonOrLink href={viewUrl}>
          <PremiumGalleryThumb gallery={gallery} />
        </PlainButtonOrLink>
      }
      label={
        <PlainButtonOrLink className={s['gallery-name']} href={viewUrl}>
          {gallery.name}
        </PlainButtonOrLink>
      }
      suffix={
        <PremiumGalleryActions
          className={s['context-menu']}
          gallery={gallery}
        />
      }
      bottomSlot={statsAndControls}
    />
  );
};
PremiumGalleryListItem.displayName = 'PremiumGalleryListItem';

export default PremiumGalleryListItem;
